import React, { useEffect, useState } from "react";
import { Users } from "lucide-react";
import api from "@/lib/api";

export default function ParticipantsPage() {
  const [people, setPeople] = useState(null);

  useEffect(() => {
    api.get("/meetings/directory/participants").then((r) => setPeople(r.data)).catch(() => setPeople([]));
  }, []);

  return (
    <div className="max-w-3xl mx-auto px-5 sm:px-8 py-8" data-testid="participants-page">
      <h1 className="font-heading text-2xl font-semibold text-white flex items-center gap-2"><Users className="w-6 h-6 text-cyan-400" /> Participants</h1>
      <p className="text-sm text-slate-400 mt-1">Everyone who has joined a meeting you hosted.</p>

      <div className="glass-panel rounded-2xl divide-y divide-white/5 mt-6" data-testid="participants-list">
        {people === null && <p className="p-6 text-sm text-slate-400 text-center">Loading...</p>}
        {people?.length === 0 && <p className="p-6 text-sm text-slate-400 text-center">No participants yet — once people join your meetings, they'll show up here.</p>}
        {people?.map((p) => (
          <div key={p.user_id} className="flex items-center gap-3 p-3.5" data-testid={`participant-row-${p.user_id}`}>
            <div className="w-8 h-8 rounded-full bg-cyan-500/20 flex items-center justify-center text-cyan-300 text-xs font-bold shrink-0">{p.name?.[0]?.toUpperCase() || "?"}</div>
            <span className="flex-1 text-sm text-white truncate">{p.name}</span>
            <span className="text-xs text-slate-400">{p.meetings_together} meeting{p.meetings_together !== 1 ? "s" : ""} together</span>
          </div>
        ))}
      </div>
    </div>
  );
}
